import { useState } from "react";
import { MdAdd } from "react-icons/md";
import NewDeliveryNote from "./NewDeliveryNote";
import "./GoodsIssueBooking.scss";

function getCurrentMonthRange() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const format = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const monthStr = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${monthStr}.${date.getFullYear()}`;
  };
  return `${format(first)} - ${format(last)}`;
}

export default function GoodsIssueBooking() {
  const [isDeliveryNoteOpen, setIsDeliveryNoteOpen] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [period] = useState(getCurrentMonthRange);

  return (
    <section className="sales-layout__page goods-issue-booking" aria-labelledby="goods-issue-booking-title">
      <div className="goods-issue-booking__layout">
        <div className="goods-issue-booking__main">
          <div className="goods-issue-booking__top-row">
            <header className="goods-issue-booking__header">
              <h1 id="goods-issue-booking-title">Lieferscheine Warenausgänge</h1>
              <p>Übersicht aller ausgehenden Lieferscheine und Erstellung neuer Belege.</p>
            </header>

            <div className="goods-issue-booking__primary">
              <button
                type="button"
                className="goods-issue-booking__btn-action goods-issue-booking__btn-action--primary"
                onClick={() => setIsDeliveryNoteOpen(true)}
              >
                <MdAdd aria-hidden="true" /> Neuer Lieferschein
              </button>
            </div>
          </div>
        </div>

        <aside className="goods-issue-booking__filters" aria-labelledby="goods-issue-filters-title">
          <h2 id="goods-issue-filters-title" className="goods-issue-booking__filters-title">
            Filter
          </h2>

          <div className="goods-issue-booking__field">
            <label htmlFor="goods-issue-period">Lieferscheine für Zeitraum</label>
            <p id="goods-issue-period" className="goods-issue-booking__period">
              {period}
            </p>
          </div>

          <div className="goods-issue-booking__field">
            <label htmlFor="goods-issue-imei">Seriennummer / IMEI</label>
            <input
              id="goods-issue-imei"
              name="imei"
              type="text"
              inputMode="numeric"
              placeholder="Seriennummer oder IMEI"
            />
          </div>

          <label className="goods-issue-booking__switch">
            <input
              type="checkbox"
              name="showCompleted"
              role="switch"
              checked={showCompleted}
              onChange={(event) => setShowCompleted(event.target.checked)}
            />
            <span className="goods-issue-booking__switch-track" aria-hidden="true" />
            <span>Erledigte Aufträge anzeigen</span>
          </label>

          <div className="goods-issue-booking__filter-actions">
            <button
              type="button"
              className="goods-issue-booking__btn-action goods-issue-booking__btn-action--secondary"
            >
              anzeigen
            </button>
            <button
              type="button"
              className="goods-issue-booking__btn-action goods-issue-booking__btn-action--danger"
            >
              Zurücksetzen
            </button>
          </div>
        </aside>
      </div>

      {isDeliveryNoteOpen && <NewDeliveryNote onClose={() => setIsDeliveryNoteOpen(false)} />}
    </section>
  );
}
